// Mapa
(function () {
  "use strict";

  let map;
  let bounds;
  let caixa;
  let markers = {};
  let locais = [];

  const $mapEl = $("#mapa");
  const iconeMc = url_base + "app/assets/dist/img/maps/marker.png";
  const clusterImg = url_base + "app/assets/dist/img/maps/m";

  // Obtém os imóveis e suas coordenadas
  function getLocais() {
    const locaisJSON = $mapEl.data("locais");
    locaisJSON.forEach((item, index) => {
      if (item.lat != "" && item.lng != "") {
        let newLat = Number(item.lat);
        let newLng = Number(item.lng);

        // Verifica se existe outro local no mesmo endereço
        const sameLocation = locais.some(
          (local) => local.lat === newLat && local.lng === newLng
        );
        // Caso possua outro local no mesmo endereço, ajusta a localicação colocando um pouco para o lado
        if (sameLocation) {
          newLat = newLat + (Math.random() - 0.5) / 1500;
          newLng = newLng + (Math.random() - 0.5) / 1500;
        }
        locais.push({
          id: item.id,
          url: item.url,
          lat: newLat,
          lng: newLng,
          img: item.foto,
          endereco: item.endereco,
          estado: item.estado,
          cidade: item.cidade,
          bairro: item.bairro,
          telefone: item.telefone,
          whatsapp: item.whatsapp,
          whatsappNumeros: item.whatsapp.replace(/\D/g, ""),
          titulo: item.titulo,
          //subtitulo: item.tipo,
          marker: iconeMc,
        });
      }
    });
  }

  // Popula os locais no mapa
  function populaLocais() {
    getLocais();
    if (locais.length > 0) {
      bounds = new google.maps.LatLngBounds();
      locais.forEach(function (local) {
        const position = {
          lat: local.lat,
          lng: local.lng,
        };
        bounds.extend(position);
        const marker = new google.maps.Marker({
          map: map,
          animation: google.maps.Animation.DROP,
          position: position,
          icon: { url: local.marker, scaledSize: new google.maps.Size(36, 36) },
        });
        marker.addListener("click", function () {
          caixa.setContent(`
            <a href="${local.url}" id="select-${local.id}" class="map-popup">
              <div class="map-popup-infos">
                <div class="map-popup-titulo">${local.titulo}</div>
                <div class="map-popup-local">${local.endereco}</div>
                <div class="map-popup-local">${local.bairro}, ${local.cidade}, ${local.estado}</div>
                <a href="tel:${local.telefone}" class="map-popup-telefone"><i class="fas fa-phone"></i>${local.telefone}</a>
                <a href="https://api.whatsapp.com/send?phone=55${local.whatsappNumeros}&text=Olá, gostaria de saber mais sobre os produtos Sartori" target="_blanck" class="map-popup-telefone"><i class="fab fa-whatsapp"></i>${local.whatsapp}</a>
              </div>
            </a>`);
          caixa.open(map, marker);
        });
        markers[local.id] = marker;
      });
      if (locais.length > 1) {
        map.fitBounds(bounds);
      } else {
        map.setCenter(bounds.getCenter());
        map.setZoom(15);
      }

      /* const markerCluster = new MarkerClusterer(map, markers, {
        imagePath: clusterImg,
      }); */
    }
  }

  // Inicializa o mapa da tela
  function initMap() {
    let gestureHandling = isMobileX(760) ? "greedy" : "auto";
    map = new google.maps.Map(document.getElementById("mapa"), {
      mapTypeControl: true,
      streetViewControl: true,
      gestureHandling: gestureHandling,
      // styles: []
    });
    caixa = new google.maps.InfoWindow();
    google.maps.event.addListener(map, "click", function () {
      caixa.close();
    });
    populaLocais();
  }

  $(window).load(function () {
    if ($("#mapa").length > 0) {
      initMap();
    }
  });
})();
